// extracted by mini-css-extract-plugin
export var contrastLow = "_20-1";
export var externalLink = "_20-2";
export var externalLinkIcon = "_20-3";
export var link = "_20-0";
export var linkLabel = "_20-4";